import React, { createRef } from 'react';
import { IonAlert, IonChip, IonButton, IonTextarea, IonInput, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonText } from '@ionic/react';
import '../styles/FlashcardEditorModal.scss';
import Storage from '../Storage';
import Utilities from '../Utilities';
import SQLStorage from '../SQLStorage';

import Drawer from '@material-ui/core/Drawer';
import TagEditorModal from './TagEditorModal';
import LinkEditorModal from './LinkEditorModal';
import { closeCircle, add, starOutline, checkmarkOutline, book, star, eye, image, arrowDownOutline, trash, trendingUp, checkmark, checkmarkCircle, play, playOutline, sync, playCircle, checkmarkDoneCircle, school, albums, notifications, logIn, logOut, refresh, layers, flash, pricetag, create, ellipsisHorizontal, closeOutline, close, attach, bookmark, bookmarks, link, text, linkOutline, chevronBack, addCircle, fileTrayFull, copy, newspaper, language, expand } from 'ionicons/icons';

import store from '../state/store';
import { updatedSetsSet } from '../state/actions/UpdatedSets';

import { isPlatform } from '@ionic/react';
import ImagePreviewModal from './ImagePreviewModal';
import HelpOverlay, { ArrowComponent } from './HelpOverlay';
import AggregatorModal from './AggregatorModal';
import { SwipeableDrawer } from '@material-ui/core';

import { Keyboard } from '@capacitor/keyboard';
const stringSimilarity = require("string-similarity");

class FlashcardEditModal extends React.Component {

   constructor(props) {

        super(props);
        this.modalRef = createRef();
        this.state = {
            keyboardShowing: false,
            flashcard: this.props.flashcard,
            oldTerm: this.props.flashcard ? this.props.flashcard.term : "",
            oldDefinition: this.props.flashcard ? this.props.flashcard.definition : "",
            oldCustomText2: this.props.flashcard ? JSON.parse(JSON.stringify(this.props.flashcard.customText2)) : [],
            oldLinks: this.props.flashcard ? JSON.parse(JSON.stringify(this.props.flashcard.links)) : [],
            linkedCards: [],
            hasChanged: false,
            currentlyEditedTag: null,
            successToast: null,
            imageUploading: false,
            stats: {},
            scrollIndicatorHidden: false,
            showHistory: false,
            deleteOptions: null,
            openImageI: null,
            showGuide: !localStorage.getItem("help-overlay-hidden-flashcard-edit-modal"),
            linkEditorOpen: null,
            openSubCardI: null,
            termSimilarityMatches: [],
            aggregatorModal: null,
            addedNewImage: false,
        }

        Utilities.trackEvent("Flashcard", "Flashcard Open Edit", this.props.flashcard ? this.props.flashcard.id : "");

        this.getLinkedCards();

        if (isPlatform("ios") || isPlatform("android")) {

            //  // Keyboard.setResizeMode("body")

            Keyboard.addListener('keyboardWillShow', (info) => {
                this.setState({ keyboardShowing: true })
                window.keyboardHeight = info.keyboardHeight;
                if (isPlatform("ios")) {
                    if (this.modalRef.current) {
                        this.modalRef.current.parentNode.style.setProperty('bottom', info.keyboardHeight + "px");
                        // this.modalRef.current.style.setProperty('margin-top', (info.keyboardHeight + (window.notchSizeTop || 0) ) + "px", "important");
                    }
                }
            });

            Keyboard.addListener('keyboardWillHide', () => {
                this.setState({ keyboardShowing: false })
                if (isPlatform("ios")) {
                    if (this.modalRef.current) {
                        this.modalRef.current.parentNode.style.setProperty('bottom', 0 + "px");
                        // this.modalRef.current.style.setProperty('margin-top', "12px", "important");
                    }
                }
            });

        }

        if (props.new) {
            this.autoFocus();
        }

    }

    componentDidMount() {
        this.calculateStats();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open) {
            Utilities.onDrawerShow();
            this.setState({
                keyboardShowing: false,
                flashcard: nextProps.flashcard,
                oldTerm: nextProps.flashcard.term,
                oldDefinition: nextProps.flashcard.definition,
                oldCustomText2: JSON.parse(JSON.stringify(nextProps.flashcard.customText2)),
                oldLinks: nextProps.flashcard.links,
                linkedCards: [],
                hasChanged: false,
                successToast: window.ln.cardSaved,
                scrollIndicatorHidden: false,
                showHistory: false,
                termSimilarityMatches: [],
                addedNewImage: false
            }, function() {
                this.calculateStats();
                this.getLinkedCards();
                setTimeout(function() {
                    this.setState({ successToast: null })
                }.bind(this), 1500);
                this.autoFocus();
            })
        }
    }

    async getLinkedCards() {
        console.log("getLinkedCards() ", this.state.flashcard.links)
        if (this.state.flashcard.links.length !== 0) {
            let cards = await SQLStorage.getCardsByIds(this.state.flashcard.links, true);
            console.log("getLinkedCards() => Reloaded links: ", cards)
            this.setState({
                linkedCards: cards,
            })
        }
    }

    async autoFocus(count = 0) {
        let element = document.getElementById("term");
        if (element) {
            console.log("FOCUSING INTO", element)
            element.focus();
        } else {
            if (count < 10) {
                setTimeout(function() {
                    this.autoFocus(count++)
                }.bind(this), 50);
            }
        }
    }

    async handleCardChange(key, value) {

        let card = this.state.flashcard;

        if (key === "term") {
            card.term = value;
        } else if (key === "definition") {
            card.definition = value;
        }

        this.setState({ flashcard: card, hasChanged: true })

    }

    async toggleStar() {

        let card = this.state.flashcard;
        Utilities.trackEvent("Flashcard", "Flashcard Star", this.state.flashcard.id, card.star ? 0 : 1);

        card.history.push( ((card.star) ? "2" : "1") + "_star_" + Utilities.timestamp() );
        card.star = !card.star

        this.setState({ flashcard: card, hasChanged: true })

        this.props.updateTagReferences("star", card.star)

    }

    async setStrength(strength) {

        let card = this.state.flashcard;
        Utilities.trackEvent("Flashcard", "Flashcard Strength Update", this.state.flashcard.id, strength);

        let oldStrength = card.strength;

        if (oldStrength === strength) {
            return;
        }

        card.strength = strength;
        this.props.updateTagReferences("strength-" + oldStrength, false)
        card.history.push("2_strength-" + oldStrength + "_" + Utilities.timestamp());
        this.props.updateTagReferences("strength-" + card.strength, true)
        card.history.push("1_strength-" + card.strength + "_" + Utilities.timestamp());

        this.setState({ flashcard: card, hasChanged: true })

    }

    async toggleTag(tagId, noRemoveIfAlreadyAdded) {

        let card = this.state.flashcard;

        if (!card.tags) card.tags = [];
        let location = card.tags.indexOf(tagId);

        Utilities.trackEvent("Flashcard", "Flashcard Tag Toggle", this.state.flashcard.id + "|" + tagId, location !== -1 ? 0 : 1);

        if (location !== -1) {
            if (!noRemoveIfAlreadyAdded) {
                card.tags.splice(location, 1);
                this.props.updateTagReferences(tagId, false)
                card.history.push("2_" + tagId + "_" + Utilities.timestamp());
            }
        } else {
            card.tags.push(tagId);
            this.props.updateTagReferences(tagId, true)
            card.history.push("1_" + tagId + "_" + Utilities.timestamp());
        }

        // { this.reloadStatistics() })

        this.setState({ flashcard: card, hasChanged: true })

    }

    async save(noAutoAddNew) {
        let flashcard = this.state.flashcard;
        flashcard.term = flashcard.term.trim();
        flashcard.definition = flashcard.definition.trim();
        if (this.state.hasChanged && (flashcard.term || flashcard.definition || flashcard.image || (flashcard.customText2 && flashcard.customText2.length !== 0) )) {
            Utilities.trackEvent("Flashcard", "Flashcard Save", flashcard.id);
            if (flashcard.term !== this.state.oldTerm) {
                flashcard.history.push("4_t_" + Utilities.timestamp());
            }
            if (flashcard.definition !== this.state.oldDefinition) {
                flashcard.history.push("5_t_" + Utilities.timestamp());
            }
            if (flashcard.customText2.length !== this.state.oldCustomText2.length) {
                flashcard.history.push("6_t_" + Utilities.timestamp());
            }
            if (flashcard.customText2) {
                flashcard.customText2 = flashcard.customText2.map(item => item.replace(/\n/g, ""));
            }
            flashcard.definition = flashcard.definition.replace(/\n/g, "").trim();
            await SQLStorage.saveCard(flashcard, false, true, this.state.oldLinks && (this.state.oldLinks.length !== 0 || this.state.flashcard.links.length !== 0) ? this.state.oldLinks : undefined);
            store.dispatch(updatedSetsSet([flashcard.setId]))
            await window.dropbox.queueForUpload("card", flashcard.id + "-" + flashcard.setId);
            this.props.onClose(this.state.hasChanged ? flashcard : null, noAutoAddNew || this.props.newOnSave, this.state.addedNewImage)
        } else {
            this.props.onClose(this.state.hasChanged && (flashcard.term || flashcard.definition || flashcard.image) ? flashcard : null, false, this.state.addedNewImage)
        }
    }

    editTag = (id) => {

        this.setState({
            currentlyEditedTag: (id === "new") ? {
                id: "" + Utilities.getId(),
                color: "1",
                name: "",
                createdAt: new Date(),
                updatedAt: new Date(),
            } : this.state.tags.filter(item => { return (item.id === id) })[0]
        })

    }

    async saveTag(tag) {
        await SQLStorage.saveTag(tag);
        await window.dropbox.queueForUpload("tag", tag.id);
        this.toggleTag(tag.id, true);
        this.props.onNewTag(tag)
    }

    async deleteCard() {
        Utilities.trackEvent("Flashcard", "Flashcard Delete", this.state.flashcard.id);
        store.dispatch(updatedSetsSet([this.state.flashcard.setId]))
        await SQLStorage.deleteCard(this.state.flashcard.id);
        await window.dropbox.queueForUpload("card", this.state.flashcard.id + "-" + this.state.flashcard.setId);
        this.props.onDelete()
    }

    async archiveCard() {
        Utilities.trackEvent("Flashcard", "Flashcard Archive", this.state.flashcard.id);
        let flashcard = this.state.flashcard;
        flashcard.customInt1 = 1;
        this.setState({
            flashcard: flashcard,
            hasChanged: true
        }, async () => {
            await this.save();
            this.props.onDelete();
        })  
    }

    async calculateStats() {
        let item = this.state.flashcard;
        if (item && typeof item.history === "object") {
            let practiceCount = 0;
            let alertCount = 0;
            let flashcardCount = 0;
            let mistakesCount = 0;
            let correctsCount = 0;

            let revisionSchedule = await SQLStorage.getSetting("spacedRepetitionCycles");
            revisionSchedule = revisionSchedule ? JSON.parse(revisionSchedule).length : 0;

            for (let i = 0; i < item.history.length; i++) {
                const happening = item.history[i].split("_");
                const actionCode = happening[0];
                if (actionCode === "10") {
                    alertCount++;
                } else if (actionCode === "11") {
                    flashcardCount++;
                } else if (actionCode === "10") {
                    alertCount++;
                } else if (actionCode === "pronounce" || actionCode === "select" || actionCode === "type" || actionCode.indexOf("term") !== -1 || actionCode.indexOf("definition") !== -1) {
                    practiceCount++;
                    if (happening[1] === "1") {
                        correctsCount++;
                    } else {
                        mistakesCount++;
                    }
                }
            }

            let stats = {
                reviewCount: item.reviewCount || "0",
                practiceCount: practiceCount,
                flashcardCount: flashcardCount,
                alertCount: alertCount,
                revisionCycle: (item.revisionCycle && item.revisionCycle !== 100 ? item.revisionCycle : '-'),
                revisionLeft: (revisionSchedule && item.revisionCycle && item.revisionCycle !== 100 && revisionSchedule > item.revisionCycle) ? (revisionSchedule - item.revisionCycle) : "-",
                lastReviewed: (item.lastReviewed ? Utilities.timeSince(item.lastReviewed*1000, true) : '-'),
                nextReview: (item.reviewAfter ? Utilities.inDays(new Date(item.reviewAfter*1000)) : '-'),
                corrects: correctsCount,
                mistakes: mistakesCount,
            };

            this.setState({ stats: stats })
        }
    }

    async getAgain() {
        let card = await SQLStorage.getCardById(this.props.open);
        if (card) {
            this.setState({ flashcard: card });
        } else {
            this.props.onClose();
        }
    }

    closeHelpOverlay() {
        let el = document.getElementById("help-overlay");
        if (el) {
            el.click();
        }
    }

    render() {

        let open = this.props.open;
        let item = this.state.flashcard

        if (!item) {
            this.getAgain();
            return null;
        }

        if (this.state.deleteOptions !== null)
            return (
                <IonAlert
                    isOpen={this.state.deleteOptions !== null}
                    onDidDismiss={() => { this.setState({ deleteOptions: null }) }}
                    header={window.ln.cardDeletionH}
                    message={window.ln.cardDeletionP}
                    buttons={[
                        {
                            text: window.ln.archiveReversible,
                            role: 'delete',
                            handler: () => { this.archiveCard(); }
                        },
                        {
                            text: window.ln.deletePermanent,
                            role: 'delete',
                            handler: () => { this.deleteCard(); }
                        },
                        {
                            text: window.ln.cancel,
                            role: 'cancel',
                        },
                    ]}
                />
            )

        return (
            // <Drawer
            <SwipeableDrawer
               anchor="bottom"
               open={open !== null && open !== undefined && open !== "" && this.state.deleteOptions === null}
               key="flashcard-editor"
               onClose={ () => {
                    Utilities.onDrawerHide();
                    this.save(true);
               } }
               onOpen={ () => {
                   Utilities.onDrawerShow();
               } }
           >
                { (open !== null && open !== undefined && open !== "") &&
                   <div
                        data-keyboard-showing={this.state.keyboardShowing} 
                        ref={this.modalRef} 
                        className="swipeable-drawer-body" 
                        data-drawer="flashcard-editor" 
                        className="flashcard-editor-modal"
                        style={(this.state.showGuide) ? { overflow: 'unset' } : {}}
                    >
                        <div className="drag-indicator"></div>
                            <div className="drag-close-indicator" onClick={() => {
                            Utilities.onDrawerHide();
                            this.save(true);
                        }}>
                            <IonIcon icon={closeCircle} />
                        </div>
                        { (!this.state.keyboardShowing) &&
                            <section className="stats">
                                <div className="nums-wrapper" data-show-history={this.state.showHistory}>
                                    <div className="nums clearfix">
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#555' }}> <IonIcon icon={eye} /> </div> <div className="side"> <p>{this.state.stats.reviewCount}</p> <label>{window.ln.reviews}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#4D80E4' }}> <IonIcon icon={logOut} /> </div> <div className="side"><p>{this.state.stats.lastReviewed}</p> <label>{ window.ln.lastReview}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#7579e7' }}> <IonIcon icon={logIn} /> </div> <div className="side"><p>{this.state.stats.nextReview}</p> <label>{ window.ln.nextReview}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#ffa259' }}> <IonIcon icon={refresh} /> </div> <div className="side"><p>{this.state.stats.revisionLeft}</p> <label>{ window.ln.reviewsLeft}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#f7be16' }}> <IonIcon icon={layers} /> </div> <div className="side"><p>{this.state.stats.revisionCycle}</p> <label>{ window.ln.reviewCycle}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#fc7fb2' }}> <IonIcon icon={school} /> </div> <div className="side"><p>{this.state.stats.practiceCount}</p> <label>{window.ln.practices}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#2dce91' }}> <IonIcon icon={checkmark} /> </div> <div className="side"><p>{this.state.stats.corrects}</p> <label>{window.ln.corrects}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#fb5b5a' }}> <IonIcon icon={close} /> </div> <div className="side"><p>{this.state.stats.mistakes}</p> <label>{window.ln.mistakes}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#4D80E4' }}> <IonIcon icon={albums} /> </div> <div className="side"><p>{this.state.stats.flashcardCount}</p> <label>{window.ln.flashcards}</label> </div> </div>
                                        <div className="c"> <div className="ci" style={{ backgroundColor: '#7579e7' }}> <IonIcon icon={notifications} /> </div> <div className="side"> <p>{this.state.stats.alertCount}</p> <label>{window.ln.alerts}</label> </div> </div>
                                        <div className="c" onClick={() => {
                                            if (!this.state.showHistory) {
                                                Utilities.trackEvent("Flashcard", "Flashcard Show History", this.state.flashcard.id);
                                            }
                                            this.setState({ showHistory: !this.state.showHistory })
                                        }}> <div className="ci" style={{ backgroundColor: '#555' }}> <IonIcon icon={ this.state.showHistory ? closeOutline : expand } /> </div> <div className="side"> <p> </p> <label style={{ height: 29, width: 82, whiteSpace: "break-spaces", lineHeight: "16px", marginTop: 4 }}>{  (this.state.showHistory) ? window.ln.hideHistory : window.ln.showHistory }</label> </div> </div>
                                    </div>
                                </div>
                                { (this.state.showHistory) &&
                                    <div className="history">
                                        { ( item.history && typeof item.history === "object") && JSON.parse(JSON.stringify(item.history)).reverse().map(h => {

                                            const happening = h.split("_");
                                            const actionCode = happening[0];
                                            const actionData = happening[1];
                                            const date = new Date(parseInt(happening[2])*1000);

                                            let text = "";
                                            let color = "#555";
                                            let icon = eye;

                                            if (actionCode === "1" || actionCode === "2") {
                                                if (actionData.indexOf("strength-") !== -1) {
                                                    text += window.ln.strength + " " + [window.ln.new, window.ln.studying, null, window.ln.learnt, null, window.ln.mastered][parseInt(actionData.replace("strength-", ""))]
                                                } else if (actionData === "star") {
                                                    text += window.ln.star;
                                                } else if (actionData === "image") {
                                                    text += window.ln.image;
                                                } else {
                                                    text += window.ln.tag + actionData
                                                }
                                                text += (actionCode === "1") ? " " + window.ln.added : " " + window.ln.removed;
                                                icon = (actionData === "image") ? image : pricetag
                                                color = (actionCode === "1") ? "#2dce91" : "#fb5b5a"
                                            } else if (actionCode === "10" || actionCode === "11") {
                                                text += window.ln.reviewedFrom.replace("__", (actionCode === "10" ? window.ln.notifications : window.ln.flashcards));
                                                icon = actionCode === "10" ? notifications : albums
                                                color = actionCode === "10" ? "#7579e7" : "#4D80E4"
                                            } else if (actionCode === "pronounce" || actionCode === "select" || actionCode === "type" || actionCode.indexOf("term") !== -1 || actionCode.indexOf("definition") !== -1) {
                                                text += window.ln.reviewedPractice.replace("__", (actionData === "1" ? window.ln.successfully : window.ln.unsuccessfully)).replace("___", Utilities.capitalize(actionCode));
                                                icon = school
                                                color = (actionData === "1") ? "#2dce91" : "#fb5b5a"
                                            } else if (actionCode === "4") {
                                                text = window.ln.termUpdated
                                                icon = create
                                                color = "#ffa259"
                                            } else if (actionCode === "5") {
                                                text = window.ln.defUpdated
                                                icon = create
                                                color = "#ffa259"
                                            } else if (actionCode === "6") {
                                                text = window.ln.customUpdated
                                                icon = create
                                                color = "#ffa259"
                                            } else {
                                                return null;
                                            }

                                            return (
                                                <div className="item">
                                                    <div className="ci" style={{ backgroundColor: color }}> <IonIcon icon={icon} /> </div>
                                                    <div className="meta">
                                                        <h2>{Utilities.timeSince(date)} ({Utilities.formatDate(date, "DD/MM/YYYY HH:MM")})</h2>
                                                        <p>{text}</p>
                                                    </div>
                                                </div>
                                            )
                                        })  }
                                        <div className="item">
                                            <div className="ci" style={{ backgroundColor: '#555' }}> <IonIcon icon={create} /> </div>
                                            <div className="meta">
                                                <h2>{Utilities.timeSince(Utilities.iOSFixDate(item.createdAt))} ({Utilities.formatDate(Utilities.iOSFixDate(item.createdAt), "DD/MM/YYYY HH:MM")})</h2>
                                                <p>{window.ln.flashcardCreated}</p>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </section>
                        }
                       <section className="edit">
                            { (!this.state.showHistory && this.state.successToast) &&
                                <div className="quicks">
                                    <div className="toast">
                                        <IonIcon icon={checkmarkCircle} />
                                        <span>{this.state.successToast}</span>
                                    </div>
                                </div>
                            }
                            { (!this.state.showHistory && !this.state.successToast) &&
                                <div className="quicks">
                                    <div className="left">
                                    { (this.state.showGuide) && <ArrowComponent direction="right-top" text={window.ln.arrowStrength} styleLabel={{ width: 'calc(100vw - 124px)' }} style={{ bottom: -42, right: 20 }} /> }
                                        <div 
                                            className="strength"
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined,
                                                backgroundColor: this.state.showGuide ? ( window.dark ? '#222' : 'white' ) : undefined,
                                                borderRadius: this.state.showGuide ? 8 : 0
                                            }}
                                            onClick={() => { this.closeHelpOverlay(); }}
                                        >
                                            <div className="tile" data-selected={item.strength === 1} onClick={() => { this.setStrength(1) }}>
                                                <IonIcon style={{ color: "#00CC9A" }} icon={playCircle} />
                                                <label>{window.ln.studying}</label>
                                            </div>
                                            <div className="tile" data-selected={item.strength === 3} onClick={() => { this.setStrength(3) }}>
                                                <IonIcon style={{ color: "#4D80E4" }} icon={checkmarkCircle} />
                                                <label>{window.ln.learnt}</label>
                                            </div>
                                            <div className="tile" data-selected={item.strength === 5} onClick={() => { this.setStrength(5) }}>
                                                <IonIcon style={{ color: "#9852f9" }} icon={checkmarkDoneCircle} />
                                                <label>{window.ln.mastered}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            { (!this.state.showHistory) &&
                                <div className="term">
                                    <textarea
                                        id="term"
                                        rows={1}
                                        placeholder={this.props.defaultTerm}
                                        value={item.term || ""}
                                        type="text"
                                        id="term"
                                        onChange={(e) => {
                                            if (e.keyCode !== 13) {
                                                this.handleCardChange("term", e.target.value)
                                            }
                                        }}
                                        onBlur={() => {
                                            if (window.cardsGrouppedByLang && this.props.defaultTerm && window.cardsGrouppedByLang[this.props.defaultTerm] && this.state.flashcard.term) {
                                                let sims = []
                                                for (let i = 0; i < window.cardsGrouppedByLang[this.props.defaultTerm].length; i++) {
                                                    const word = window.cardsGrouppedByLang[this.props.defaultTerm][i].split("££")[0];
                                                    const sim = stringSimilarity.compareTwoStrings(word, this.state.flashcard.term.toLowerCase());
                                                    if (sim > 0.85) {
                                                        console.log(sim + " " + word)
                                                        sims.push({ word: word, id: window.cardsGrouppedByLang[this.props.defaultTerm][i].split("££")[1], sim: sim })
                                                    }
                                                }
                                                this.setState({
                                                    termSimilarityMatches: sims
                                                })
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                window.justJumpedField = true;
                                                let element = document.getElementById("definition");
                                                if (element) {
                                                    element.focus();
                                                }
                                            }
                                        }}
                                    />
                                    <div
                                        className='aggregator-btn'
                                        onClick={() => {
                                            if (!this.props.defaultTerm || !this.props.defaultDefinition || this.props.defaultTerm === window.ln.term || this.props.defaultDefinition === window.ln.def) {
                                                window.toast(window.ln.setLanguageRequired, "error");
                                                return;
                                            }

                                            if (!this.state.flashcard.term) {
                                                window.toast(window.ln.fieldNeedsText, "error");
                                                return;
                                            }
                                            
                                            this.setState({
                                                aggregatorModal: "term"
                                            })
                                        }}
                                    >
                                        <IonIcon icon={language} />
                                    </div>
                                    { this.state.termSimilarityMatches.length !== 0 &&
                                        <div className='similarities'>
                                            { this.state.termSimilarityMatches.map((sim) => {
                                                if (!window.activated)
                                                    return (
                                                        <div onClick={ async () => {
                                                            window.showSubscriptionModal("dupe");
                                                        }}>
                                                            {window.ln.possibleDupe}
                                                        </div>
                                                    )
                                                return (
                                                    <div onClick={ async () => {
                                                        let cards = await SQLStorage.getCardsByIds([sim.id], true);
                                                        this.setState({
                                                            linkedCards: cards,
                                                        })
                                                        this.setState({
                                                            openSubCardI: "similar",
                                                            openSubCardFull: cards[0]
                                                        })
                                                    }}>
                                                        {sim.word} <span>{Math.round(sim.sim*100)}%</span>
                                                    </div>
                                                )
                                            }) }
                                        </div>
                                    }
                                </div>
                            }
                            { (!this.state.showHistory) &&
                                <div className="definition">
                                    <textarea
                                        id="definition"
                                        rows={ window.innerWidth >= 724 ? 3 : 2}
                                        value={item.definition || ""}
                                        type="text"
                                        placeholder={this.props.defaultDefinition}
                                        id="definition"
                                        onChange={(e) => {
                                            if (window.justJumpedField) {
                                                window.justJumpedField = false;
                                            } else {
                                                this.handleCardChange("definition", e.target.value)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.keyCode === 13) {
                                                e.preventDefault()
                                                if (this.state.flashcard.customText2.length === 0) {
                                                    this.save();
                                                } else {
                                                    window.justJumpedField = true;
                                                    let element = document.getElementById("custom-1");
                                                    if (element) {
                                                        element.focus();
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                    <div
                                        className='aggregator-btn'
                                        onClick={() => {
                                            if (!this.props.defaultTerm || !this.props.defaultDefinition) {
                                                window.toast(window.ln.setLanguageRequired, "error");
                                                return;
                                            }

                                            if (!this.state.flashcard.definition) {
                                                window.toast(window.ln.fieldNeedsText, "error");
                                                return;
                                            }
                                            
                                            this.setState({
                                                aggregatorModal: "definition"
                                            })
                                        }}
                                    >
                                        <IonIcon icon={language} />
                                    </div>
                                </div>
                            }
                            { (!this.state.showHistory && this.state.flashcard.customText2) &&
                                <div className="customs">
                                    { this.state.flashcard.customText2.map((customText, i) => {
                                        return (
                                            <div className="custom">
                                                <textarea
                                                    rows={ window.innerWidth >= 724 ? 3 : 1}
                                                    value={customText || ""}
                                                    type="text"
                                                    placeholder={window.ln.customTextField}
                                                    id={"custom-" + (i+1)}
                                                    onChange={(e) => {
                                                        // if (window.justJumpedField) {
                                                        //     console.log("RESET JUST JUMPED @@")
                                                        //     window.justJumpedField = false;
                                                        // } else {
                                                            let customFields = this.state.flashcard.customText2;
                                                            customFields[i] = e.target.value
                                                            this.setState({
                                                                flashcard: {
                                                                    ...this.state.flashcard,
                                                                    customText2: customFields
                                                                },
                                                                hasChanged: true
                                                            })
                                                        // }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.keyCode === 13) {
                                                            e.preventDefault()
                                                            let nextCustomField = document.getElementById("custom-" + (i+2));
                                                            if (nextCustomField) {
                                                                window.justJumpedField = true
                                                                nextCustomField.focus();
                                                            } else {
                                                                this.save();
                                                            }
                                                        }
                                                    }}
                                                />
                                                <IonIcon
                                                    icon={close}
                                                    onClick={() => {
                                                        Utilities.trackEvent("Flashcard", "Flashcard Custom Field Remove", this.state.id);
                                                        let customFields = this.state.flashcard.customText2;
                                                        customFields.splice(i, 1);
                                                        this.setState({
                                                            flashcard: {
                                                                ...this.state.flashcard,
                                                                customText2: customFields
                                                            },
                                                            hasChanged: true
                                                        })
                                                    }}
                                                />
                                            </div>
                                        )
                                    } )}
                                </div>
                            }
                            { (!this.state.showHistory && this.state.linkedCards.length !== 0) &&
                                <div className="links">
                                    { this.state.linkedCards.map((card, i) => {
                                        return ( <IonChip data-color="8" onClick={() => {
                                            this.setState({ openSubCardI: i })
                                        }} key={card.id}> 
                                            <IonIcon icon={linkOutline} />
                                            <IonLabel>{card.term}</IonLabel>
                                        </IonChip> )
                                    }) }
                                </div>
                            }
                            { (!this.state.showHistory && (this.state.editingTags || item.tags.length !== 0) ) &&
                                <div className="tags">
                                    { (this.state.editingTags) &&
                                        <IonChip data-color="8" onClick={() => {
                                            if (this.props.tags.length > 9 && !window.activated) {
                                                window.showSubscriptionModal("tags");
                                            } else {
                                                this.editTag("new")
                                            }
                                        }}> 
                                            <IonIcon icon={addCircle} slot="end" />
                                            <IonLabel>{window.ln.addTag}</IonLabel>
                                        </IonChip>
                                    }
                                    { this.props.tags.map(tag => {
                                        if (tag.id === "star" || tag.id === "mastered" || tag.id === "image" || tag.id === "new" || tag.id === "recording" || tag.id === "learnt" || tag.id === "studying") return null;
                                        if (item.tags.indexOf(tag.id) === -1 && !this.state.editingTags) return null;
                                        return ( <IonChip onClick={() => { this.toggleTag(tag.id) }} data-ns={(item.tags.indexOf(tag.id) === -1 ? "true" : "false")} key={tag.id} data-color={tag.color}> <IonLabel>{tag.name}</IonLabel> </IonChip> )
                                    }) }
                                </div>
                            }
                            { (this.state.flashcard.customText1 && this.state.flashcard.customText1.length !== 0) &&
                                <div className="images">
                                    { this.state.flashcard.customText1.map((image, i) => {
                                        let callbackElementRand = image.startsWith("data:") ? null : (image + "-" + i);

                                        if (window.os !== "web" && callbackElementRand) {
                                            Utilities.getImage(item.id, image, true, callbackElementRand);
                                        }
                                        return (
                                            <div
                                                onClick={() => {
                                                    this.setState({ openImageI: i })
                                                }}
                                                data-rand={callbackElementRand}
                                                className="image image-loading"
                                            >
                                                { (window.os === "web" || !callbackElementRand) ?
                                                    <img src={image} />
                                                    :
                                                    null
                                                }
                                            </div>
                                        )
                                    }) }
                                </div>
                            }
                            <div className="opts" style={ this.state.showHistory ? { justifyContent: 'flex-end' } : {} }>
                                { (!this.state.showHistory) &&
                                    <div className="left">
                                        <button 
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined,
                                                padding: this.state.flashcard.image ? 0 : undefined
                                            }}
                                            onClick={ async () => {
                                                this.closeHelpOverlay();
                                                Utilities.trackEvent("Flashcard", "Flashcard Image Add Click", this.state.flashcard.id);

                                                if (!window.activated) {
                                                    let imageCardCount = await SQLStorage.getCardsCountWithImages();
                                                    if (imageCardCount > 10) {
                                                        window.showSubscriptionModal("images");
                                                        return;
                                                    }
                                                }

                                                let settings = await Storage.getO("settings");

                                                if (!window.dropbox || !settings.dropbox) {
                                                    window.preventFocusBlurTrack = true;
                                                    if(window.confirm(window.ln.dropboxImage)) {
                                                        window.startDropboxAuth();
                                                    }
                                                    setTimeout(() => {
                                                        window.preventFocusBlurTrack = false;
                                                    }, 300);
                                                } else {
                                                    if (!this.state.uploadImage) {
                                                        const element = document.getElementById("image-upload-input");
                                                        if (element) {
                                                            element.click();
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            {
                                                (this.state.imageUploading) ?  <IonIcon className="uploading" icon={sync} /> :
                                                <IonIcon icon={image} />
                                            }
                                            <IonLabel>{window.ln.image}</IonLabel>
                                            { (this.state.showGuide) && <ArrowComponent direction="left-bottom" text={window.ln.arrowImage} style={{ bottom: 50, left: 15 }} /> }
                                        </button>

                                        <button 
                                            className="field" 
                                            data-selected={item.star}
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined
                                            }}
                                            onClick={ async () => {
                                                this.closeHelpOverlay();

                                                Utilities.trackEvent("Flashcard", "Flashcard Custom Field Add Click", this.state.flashcard.id);

                                                if (!window.activated) {
                                                    let customFieldCount = await SQLStorage.getCardsCountWithCustomFields();
                                                    if (customFieldCount > 10) {
                                                        window.showSubscriptionModal("fields");
                                                        return;
                                                    }
                                                }

                                                Utilities.trackEvent("Flashcard", "Flashcard Custom Field Add", this.state.flashcard.id);

                                                let customFields = this.state.flashcard.customText2 || [];
                                                customFields.push("");
                                                this.setState({
                                                    flashcard: {
                                                        ...this.state.flashcard,
                                                        customText2: customFields
                                                    },
                                                    hasChanged: true
                                                })

                                            }}
                                        >
                                            { (this.state.showGuide) && <ArrowComponent direction="left-bottom" text={window.ln.arrowField} style={{ bottom: 50, left: 15 }} styleLabel={{ width: 150 }} /> }
                                            <IonIcon icon={text} />
                                            <IonLabel>{window.ln.field}</IonLabel>
                                        </button>

                                        <button
                                            className="tagsb"
                                            data-selected={item.star}
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined
                                            }}
                                            onClick={() => {
                                                if (!this.state.editingTags) {
                                                    Utilities.trackEvent("Flashcard", "Flashcard Tag Edit Click", this.state.flashcard.id);
                                                }
                                                this.closeHelpOverlay();
                                                this.setState({ editingTags: !this.state.editingTags }) 
                                            }}
                                        >
                                            { (this.state.showGuide) && <ArrowComponent direction="left-top" text={window.ln.arrowTag} style={{ bottom: -46, left: 15 }} /> }
                                            <IonIcon icon={pricetag} />
                                            <IonLabel>{window.ln.tags}</IonLabel>
                                        </button>

                                        <button 
                                            className="star"
                                            data-selected={item.star} 
                                            onClick={() => { 
                                                this.toggleStar();
                                                this.closeHelpOverlay();
                                            }}
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined
                                            }}
                                        >
                                            <IonIcon icon={star} />
                                            <IonLabel>{window.ln.star}</IonLabel>
                                            { (this.state.showGuide) && <ArrowComponent direction="left-top" text={window.ln.arrowStar} style={{ bottom: -46, left: 20 }} /> }
                                        </button>

                                        <button 
                                            className="link" 
                                            data-selected={item.star} 
                                            onClick={() => {
                                                Utilities.trackEvent("Flashcard", "Flashcard Link Edit Click", this.state.flashcard.id);
                                                this.closeHelpOverlay();
                                                this.setState({
                                                    linkEditorOpen: true
                                                })
                                            }}
                                            style={{
                                                zIndex: this.state.showGuide ? 100000 : undefined,
                                                position: this.state.showGuide ? 'relative' : undefined
                                            }}
                                        >
                                            { (this.state.showGuide) && <ArrowComponent direction="left-top" text={window.ln.arrowLink} styleLabel={{ width: 90 }} style={{ bottom: -46, left: 20 }} /> }
                                            <IonIcon icon={link} />
                                            <IonLabel>{window.ln.link}</IonLabel>
                                        </button>

                                        { (!this.props.preventEdit) &&
                                            <button onClick={() => {
                                                if (this.props.new) {
                                                    this.save();
                                                } else {
                                                    this.setState({
                                                        deleteOptions: true
                                                    })
                                                }
                                            }}>
                                                <IonIcon icon={trash} />
                                                <IonLabel>{window.ln.delete}</IonLabel>
                                            </button>
                                        }
                                    </div>
                                }
                                <div className="right">
                                    <button data-disabled={this.state.imageUploading ? "true" : "false"} className="save" data-has-changed={(this.state.hasChanged && (this.state.flashcard.term || this.state.flashcard.definition || this.state.flashcard.image || (this.state.flashcard.customText2 && this.state.flashcard.customText2.length !== 0) )) ? "true" : "false"} onClick={() => {
                                        if (this.state.showHistory) {
                                            this.setState({
                                                showHistory: false
                                            })
                                        } else if (!this.state.imageUploading) {
                                            if (this.props.embedded) {
                                                this.save(false)
                                            } else {
                                                this.save()
                                            }
                                        }
                                    }}>
                                        <IonIcon icon={ (this.state.hasChanged && (this.state.flashcard.term || this.state.flashcard.definition || this.state.flashcard.image || (this.state.flashcard.customText2 && this.state.flashcard.customText2.length !== 0) )) ? checkmarkCircle : closeCircle} />
                                        <span>{ 
                                            this.state.imageUploading ?
                                            (window.ln.uploading + " ...") : 
                                                this.props.embedded ? 
                                                window.ln.backToParentCard :
                                                    (this.state.hasChanged && (this.state.flashcard.term || this.state.flashcard.definition || this.state.flashcard.image || (this.state.flashcard.customText2 && this.state.flashcard.customText2.length !== 0) )) ? 
                                                    window.ln.save : (this.props.new ? (window.ln.discard) : 
                                                        window.ln.close)}
                                        </span>
                                    </button>
                                </div>
                            </div>
                       </section>
                        <input id="image-upload-input" type='file' tabIndex={-1} onChange={(e) => {
                            const files = Array.from(e.target.files)
                            console.log(files, "ON")
                            if (files && files[0]) {

                                this.setState({ imageUploading: true })

                                var FR = new FileReader();

                                FR.addEventListener("load", async function(e) {
                                    const type = e.target.result.split(';')[0].split('/')[1];
                                    let resized = await Utilities.resizeImage(e.target.result);
                                    let resizedThumbnail = await Utilities.resizeImageThumbnail(e.target.result);
                                    let fileName = Math.round((new Date()).getTime()) + "." + type;
                                    let url = await window.dropbox.uploadImage("image-" + fileName, resized).catch(e => {
                                        window.toast(window.ln.uploadImageFail, "error");
                                        this.setState({ imageUploading: false })
                                    })
                                    let urlThumb = await window.dropbox.uploadImage("thumb-" + fileName, resizedThumbnail).catch(e => {
                                        window.toast(window.ln.uploadImageFail, "error");
                                        this.setState({ imageUploading: false })
                                    })
                                    if (url && url.indexOf("dropbox") !== -1 && urlThumb && urlThumb.indexOf("dropbox") !== -1) {
                                        let flashcard = this.state.flashcard;
                                        if (!flashcard.image) {
                                            flashcard.image = []
                                        }
                                        flashcard.image.push(url);
                                        if (!flashcard.customText1) {
                                            flashcard.customText1 = []
                                        }
                                        flashcard.customText1.push(urlThumb);
                                        // flashcard.customText1.push(resizedThumbnail);
                                        flashcard.history.push("1_image_" + Utilities.timestamp());
                                        this.setState({
                                            hasChanged: true,
                                            flashcard: flashcard,
                                            imageUploading: false,
                                            successToast: window.ln.imageUploaded,
                                            addedNewImage: true
                                        }, function() {
                                            setTimeout(function() {
                                                this.setState({ successToast: null })
                                            }.bind(this), 1250);
                                        })
                                        Utilities.trackEvent("Flashcard", "Flashcard Image Add", this.state.flashcard.id);
                                    }
                                }.bind(this));

                                FR.readAsDataURL( files[0] );

                            }
                        }} />
                        { (this.state.showGuide) &&
                            <HelpOverlay 
                                view="flashcard-edit-modal"
                                close={() => { this.setState({ showGuide: false }) }}
                            />    
                        }
                   </div>
               }
                <ImagePreviewModal
                    open={this.state.openImageI}
                    url={item.image ? item.image[this.state.openImageI] : null}
                    onClose={() => {
                        this.setState({
                            openImageI: null
                        })
                    }}
                    cardId={this.state.flashcard.id}
                    allowDelete={true}
                    onDelete={() => {
                        window.preventFocusBlurTrack = true;
                        if (window.confirm(window.ln.deleteImgConfirm)) {
                            Utilities.trackEvent("Flashcard", "Flashcard Image Delete", this.state.flashcard.id);
                            let flashcard = this.state.flashcard;
                            flashcard.image.splice(this.state.openImageI, 1);
                            flashcard.customText1.splice(this.state.openImageI, 1);
                            flashcard.history.push("2_image_" + Utilities.timestamp());
                            this.setState({
                                flashcard: flashcard,
                                hasChanged: true,
                                openImageI: null
                            })
                        }
                        setTimeout(() => {
                            window.preventFocusBlurTrack = false;
                        }, 300);
                    }}
                />
                <TagEditorModal
                    currentlyEditedTag={this.state.currentlyEditedTag}
                    onSave={(tag) => { this.saveTag(tag) }}
                    onClose={() => { this.setState({ currentlyEditedTag: null }) }}
                />
                <AggregatorModal 
                    open={this.state.aggregatorModal || null}
                    term={this.state.flashcard ? this.state.flashcard.term || "" : ""}
                    definition={this.state.flashcard ? this.state.flashcard.definition || "" : ""}
                    termLang={this.props.defaultTerm}
                    definitionLang={this.props.defaultDefinition}
                    onClose={(resultType, resultData) => {
                        if (resultData && resultData.length !== 0) {
                            if (resultType === "context" || resultType === "synonym") {
                                let customFields = this.state.flashcard.customText2 || [];
                                for (let i = 0; i < resultData.length; i++) {
                                    const res = resultData[i];
                                    customFields.push(res.to ? res.from + " - " + res.to : res.from);   
                                }
                                this.setState({
                                    flashcard: {
                                        ...this.state.flashcard,
                                        customText2: customFields
                                    },
                                    hasChanged: true
                                })
                            } else {
                                this.setState({
                                    flashcard: {
                                        ...this.state.flashcard,
                                        term: this.state.aggregatorModal === "term" ? this.state.flashcard.term : resultData.map(item => item.from).join(", "),
                                        definition: this.state.aggregatorModal === "definition" ? this.state.flashcard.definition : resultData.map(item => item.from).join(", "),
                                    },
                                    hasChanged: true
                                })
                            }
                        }
                        console.log(resultType, resultData, "<<<<<<<<<<<<<<<<<<<<<,");
                        this.setState({
                            aggregatorModal: null
                        })
                    }}
                />
                <LinkEditorModal
                    cardId={this.state.linkEditorOpen ? this.state.flashcard.id : null}
                    currentLinks={this.state.flashcard.links || []}
                    onClose={(links) => {
                        if (links) {
                            let flashcard = this.state.flashcard;
                            flashcard.links = links;
                            this.setState({
                                linkEditorOpen: false,
                                flashcard: flashcard,
                                linkedCards: [],
                                hasChanged: true
                            }, () => {
                                this.getLinkedCards();
                            })
                            // TO DO history - update for all
                            // flashcard.history.push("1_link_" + Utilities.timestamp());
                        } else {
                            this.setState({
                                linkEditorOpen: false
                            })
                        }
                    }}
                />
                { (this.state.openSubCardI !== null) &&
                    <FlashcardEditModal
                        onNewTag={(tag) => { }}
                        open={this.state.openSubCardI}
                        flashcard={ this.state.openSubCardI === "similar" ? this.state.openSubCardFull : this.state.linkedCards[this.state.openSubCardI]}
                        defaultTerm=""
                        defaultDefinition=""
                        tags={this.props.tags}
                        updateTagReferences={(a, b) => { }}
                        onDelete={() => {

                        }}
                        onClose={ async (changedCard) => {
                            this.setState({ openSubCardI: null })
                        }}
                        embedded={true}
                    />
                }
           </SwipeableDrawer>
        );
    }

};


export default withIonLifeCycle(FlashcardEditModal);
